import React from 'react';
import PropTypes from 'prop-types';

const BottomPadding = ({ children, isActive }) => (
  <div style={{ paddingBottom: isActive ? 126 : 0 }}>
    {children}
  </div>
);
BottomPadding.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
  ]).isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default BottomPadding;
